import Vue from 'vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue';
import router from './router';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import VueMeta from 'vue-meta';
Vue.use(VueMeta);

Vue.use(ElementUI);
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);

Vue.config.productionTip = false;

function setRem() {
  const baseSize = 16; // 基准字号，相当于 1rem = 16px
  const scale = document.documentElement.clientWidth / 1920; // 按照 1920 设计图缩放
  document.documentElement.style.fontSize = baseSize * Math.min(scale, 2) + 'px';
}

setRem();
window.addEventListener('resize', setRem);

new Vue({
  router,
  render: h => h(App)
}).$mount('#app');